import {validateExpiryMonthAndYear} from './zepz-form.validators';

export const FIELDS = {
    customerName: {
        name: 'customerName',
        id: 'customerName-field'
    },
    cardNumber: {
        name: 'cardNumber',
        id: 'cardNumber-field',
        fromIframe: true
    },
    expiryDate: {
        name: 'expiryDate',
        id: 'expiryDate-field',
        validator: validateExpiryMonthAndYear,
        defaultValue: ''
    },
    securityCode: {
        name: 'securityCode',
        id: 'securityCode-field',
        fromIframe: true
    },
    shouldSaveCard: {
        name: 'shouldSaveCard',
        id: 'shouldSaveCard-field',
        defaultValue: true
    }
};
